module.exports = "/images/trialproofer-app-image.png?4509589e3024a302a7ea6c16b1d2ca63";